import { Box, Button, Skeleton, Typography } from "@mui/material";
import styled from "styled-components";
import { TypoRepro } from "../chatStyled";

export const SubscriberPageWrapper = styled(Box)({
    display: 'flex',
    width: '100%',
    paddingBottom: '40px',
    marginTop: '20px',
});

export const PageGrid = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 24px;
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
`;

export const ChatWrapperButton = styled.div`
    width: 100%;

    @media (max-width: 768px) {
        max-width: none;
    }
`;

export const VideoGrid = styled(Box)({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'flex-start',

    '@media (max-width: 768px)': {
        width: '100%'
    }
});

export const VideoCell = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '12px',
    backgroundColor: '#fff',
    padding: '16px',
    paddingBottom: '7px',
    boxShadow: '0 4px 4px -1px rgba(0,0,0,.1),0 6px 12px 1px rgba(0,0,0,.1)',
    width: '448px',
    maxWidth: '448px',

    '@media (max-width: 768px)': {
        width: '100%',
        height: '100%',
        maxWidth: '100%',
    }
});

export const VideoThumbnailWrapper = styled(Box)({
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '8px',
    backgroundColor: '#2e2a28',

    '@media (max-width: 768px)': {
        height: 'auto !important',
        aspectRatio: '416/288',
    }
});

export const VideoThumbnail = styled.img({
    width: '416px',
    height: '288px',
    objectFit: 'cover',
    display: 'block',
    borderRadius: '8px',

    '@media (max-width: 768px)': {
        width: '100%',
        height: '100%',
    }
});

export const VideoThumbnailFallback = styled(Box)({
    width: '416px',
    height: '288px',
    backgroundColor: '#2e2a28',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '@media (max-width: 768px)': {
        width: '100%',
        height: '100%',
    }
});

export const PlayOverlay = styled(Box)({
    position: 'absolute',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
});

export const VideoCellMeta = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '15px',
    width: '100%',
    minWidth: 0,
});

export const VideoName = styled(TypoRepro)({
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    paddingRight: '10px',
    fontWeight: 500,
    fontFamily: 'Repro, sans-serif',
    fontSize: '16px',
    lineHeight: '20px',
    flex: 1,
});

export const VideoDate = styled(TypoRepro)({
    fontSize: '14px',
    color: '#969090',
    whiteSpace: 'nowrap',
    flexShrink: 0,
});

export const WatchVideoButton = styled(Button)({
    fontSize: '16px !important',
    fontFamily: 'Repro, sans-serif !important',
    fontWeight: 700,
    lineHeight: '87%',
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: '100px',
    width: '100%',
    textTransform: 'none',
    padding: '18px 22px',
    marginTop: '15px',  
    '&:hover': {
        backgroundColor: '#222',
    },
});

export const ChatIndicatorWrapper = styled(Box)({
    maxWidth: '453px',
    width: '100%',
    marginLeft: '16px',
    '@media (max-width: 768px)': {
        display: 'none',
    },
});

export const ChatCell = styled(Box)({
    border: '2px solid #ECE9E4',
    backgroundColor: '#fff',
    padding: '20px 16px 15px 16px'
});

export const ChatCellIcon = styled(Box)({
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
    '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
});

export const ChatCellLabel = styled(TypoRepro)({
    fontFamily: "'Repro GT Super Text', sans-serif",
    fontWeight: 350,
    fontSize: '36px',
    lineHeight: '1',
    textTransform: 'capitalize',
    color: '#1D1A1A',
    textAlign: 'center',
    marginBottom: '40px',
});

export const MessageCounter = styled.p`
    font-family: 'Repro', sans-serif;
    font-size: 22px;
    font-weight: 500;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 12px;
`;

export const BtnOpenChat = styled(Button)({
    fontFamily: "'Repro', sans-serif",
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '1',
    textTransform: 'capitalize',
    backgroundColor: '#FD3300',
    color: '#fff',
    padding: '14px',
    borderRadius: '100px',
    borderWidth: '2px',
    width: '100%',
    '&:hover': {
        backgroundColor: '#E62A00',
    },
});

export const HrLine = styled.hr`
    margin-bottom: 12px;
`;

export const VideoSkeletonCell = styled(Skeleton)({
    borderRadius: '12px',
    aspectRatio: '16 / 9',
    transform: 'none',
    height: 'auto',
});

export const VideoCardSkeleton = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '12px',
    backgroundColor: '#fff',
    padding: '16px',
    paddingBottom: '7px',
    boxShadow: '0 4px 4px -1px rgba(0,0,0,.1),0 4px 4px -2px rgba(0,0,0,.1)',
    '@media (max-width: 768px)': {
        width: '100%',
    },
});

export const VideoSkeletonThumbnail = styled(Skeleton)({
    width: '416px',
    height: '288px',
    borderRadius: '8px',
    transform: 'none',
    flexShrink: 0,
    '@media (max-width: 768px)': {
        width: '100%',
        height: 'auto',
        aspectRatio: '416/288',
    },
});

export const VideoSkeletonMeta = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
    marginTop: '15px',
});

export const VideoSkeletonName = styled(Skeleton)({
    borderRadius: '4px',
    height: '20px',
    flex: 1,
    transform: 'none',
});

export const VideoSkeletonDate = styled(Skeleton)({
    borderRadius: '4px',
    height: '14px',
    width: '70px',
    flexShrink: 0,
    transform: 'none',
});

export const VideoSkeletonButton = styled(Skeleton)({
    borderRadius: '100px !important',
    height: '54px',
    width: '100%',
    marginTop: '15px',
    transform: 'none',
});

export const ChatIndicatorSkeleton = styled(Skeleton)({
    borderRadius: '0 !important',
    height: '230px',
    width: '100%',
    transform: 'none',
});

export const EmptyState = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 24px',
    gap: '16px',
});

export const EmptyStateText = styled(TypoRepro)({
    fontWeight: 400,
    fontSize: '16px',
    color: '#7B726C',
    textAlign: 'center',
});
